import React from 'react';
import {Redirect} from 'react-router-dom';

import {createRoutes} from '../@crema/utility/Utils';
import {authRouteConfig} from './auth';
import {initialUrl} from '../shared/constants/AppConst';
import { adminPagesConfig } from './admin';
import { appointmentsConfig } from './admin/Appointments';
import { errorPagesConfigs } from './errorPages';
import { patientSettingsConfig } from './admin/AddPatient';
import { addPractitionerConfig } from './admin/AddPractitioner';
import { selfReferralsConfig } from './admin/SelfReferrals';
import { patientRecordsConfig } from './admin/PatientRecords';
import { dashboardConfig } from './admin/Dashboard';
import { thirdPartyReferralsConfig } from './admin/ThirdPartyReferrals';
import { oakTreeReferralsConfig } from './admin/OaktreeReferral';
import { reportsAnalyticsConfig } from './admin/ReportsAnalytics';
import { practitionerviewConfig } from './admin/PractitionerView';
import { addOrganizationConfig } from './admin/AddOrganization';
//import { addOrganizationUsersConfig } from './admin/AddOrganizationUsers';
import { settingsListConfig} from './admin/Settings';
import { siteSettingsListConfig } from './admin/SiteSetting';
import { appointmentSettingsConfig } from './admin/AppointmentSettings';

const routeConfigs = [
  ...authRouteConfig,
  ...adminPagesConfig,
  ...appointmentsConfig,
  ...errorPagesConfigs,
  ...patientSettingsConfig,
  ...addPractitionerConfig,
  ...selfReferralsConfig,
  ...patientRecordsConfig,
  ...dashboardConfig,
  ...thirdPartyReferralsConfig,
  ...reportsAnalyticsConfig,
  ...practitionerviewConfig,
  ...addOrganizationConfig,
 // ...addOrganizationUsersConfig,
  ...settingsListConfig,
  ...oakTreeReferralsConfig,
  ...siteSettingsListConfig,
  ...appointmentSettingsConfig
];

const routes = [
  ...createRoutes(routeConfigs),
  {
    path: '/',
    exact: true,
    component: () => <Redirect to={initialUrl} />,
  },
  {
    component: () => <Redirect to='/error-pages/error-404' />,
  },
];

export default routes;
